import React from 'react';
import GithubFeed from './GithubFeed';
import styled, { css } from 'styled-components';

import { SectionContainer } from './common/SectionContainer';
import Title from './common/Title';
import Paragraph from './common/Paragraph';
import Button from './common/Button';

import ProjectImg1 from '../img/clue--mockup.png';
import ProjectImg2 from '../img/ReDItoFind--mockup.jpg';
import ProjectImg3 from '../img/JS--mockup.png';
import ProjectImg4 from '../img/JS_exercise--mockup.png';
import ProjectImg5 from '../img/todolist--mockup.png';
import ProjectImg6 from '../img/portfolio--mockup.png';

import { COLORS, SIZE } from './common/constants';

const Projects = () => {
	return (
		<SectionContainer id='projects'>
			<TitleContainer>
				<Title title='Projects'></Title>{' '}
				<Button text='See All' link='https://github.com/wondasom'></Button>
			</TitleContainer>
			<Cards>
				{projects.map((item) => (
					<Card>
						<a href={item.link} target='_blank' rel='noopener noreferrer'>
							<SubtitleStyled>{item.name}</SubtitleStyled>
						</a>
						<Position>{item.description}</Position>
						<Paragraph text={item.stack}></Paragraph>
					</Card>
				))}
			</Cards>
			{/* <Subtitle subtitle='Recent Commits'></Subtitle> */}
			{/* <GithubFeed /> */}
		</SectionContainer>
	);
};

export default Projects;

// 🎨 Styled Components
const Cards = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	@media (max-width: ${SIZE.medium}) {
		flex-direction: column;
	}
`;

const Card = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 1em 0;
`;

const SubtitleStyled = styled.h2`
	font-size: calc(15.6px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
	font-family: 'Montserrat', sans-serif;
	color: ${COLORS.grey};
	font-weight: 500;
	text-align: left;
	margin-bottom: 0.6rem;
	${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.mainAqua};
		`}
	&:hover {
		color: ${COLORS.somGreen};
	}
	/* &::selection{
		background-color:${COLORS.somOrange};
		color:${COLORS.white}
	} */
`;

const TitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	@media (max-width: ${SIZE.medium}) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

const Position = styled.h3`
	font-size: calc(15.6px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
	font-family: 'Montserrat', sans-serif;
	color: ${COLORS.grey};
	opacity: 0.6;
	font-weight: 500;
	text-align: left;
	margin-bottom: 0.5rem;
	${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.mainAqua};
		`}
	&::selection {
		background-color: ${COLORS.somOrange};
		color: ${COLORS.white};
	}
`;

const projects = [
	{
		name: 'Clues for the Clue',
		description: `Period tracking app Clue - user research & presentation`,
		stack: `React.js, Styled Components, mobile-first approach`,
		path: ProjectImg1,
		link: `https://clues-for-the-clue.netlify.app/`
	},
	{
		name: 'Business Card Maker',
		description: `Automatic business card maker with editor/ preview sections`,
		stack: `React.js, React Router, React Hooks, PostCSS, Firebase(Authentication, Realtime database), Cloudinary, Testable Code, Service layer`,

		link: `https://dasom-card-maker.netlify.app/`
	},
	{
		name: 'ReDI To Find',
		description: `The final project at ReDI School's React Course - to help Berliners connect to local restaurants that are open during the pandemic`,
		stack: `React.js, React Hooks, React Context, Restful APIs, Web APIs`,
		path: ProjectImg2,
		link: `https://reditofind.netlify.app/`
	},
	{
		name: 'Habit Tracker',
		description: `List style item tracking application with a counting feature`,
		stack: `React.js, State & Props management in Class Component, Pure Component, Lifecycle methods, Function Component, memo`,

		link: `https://github.com/wondasom/habit-tracker`
	},
	{
		name: 'Note.js',
		description: 'A personal study note for essential JavaScript concepts',
		stack: `JavaScript, HTML5`,
		path: ProjectImg3,
		link: `https://github.com/wondasom/JAVASCRIPT`
	},
	{
		name: 'JavaScript Toy Projects',
		description:
			'A small collection of JavaScript projects - target pointer, shopping list, carrot-game',
		stack: `JavaScript, HTML5, CSS3`,
		path: ProjectImg4,
		link: `https://github.com/wondasom/VanilaJS__exercise`
	},
	{
		name: 'Do It Already',
		description:
			'To do list application with item add, delete, toggle feature and a progress bar',
		stack: 'React.js, Lodash',
		path: ProjectImg5,
		link: `https://todolist-dasom.netlify.app/`
	}
];
